module.exports = __webpack_public_path__ + "static/media/b43@2x.4936d65d.png";